export enum ContainerTypeEnum {
  GeneralPurpose = 'GP',
  HighCube = 'HC',
  FlatRack = 'FR',
  OpenTop = 'OT',
  Refrigerated = 'RF'
}
